import { useState, useEffect, forwardRef, useImperativeHandle} from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Container,TextInput,Select,Text, NumberInput,Alert, Group,Loader,Tooltip,Anchor,Image,Modal} from '@mantine/core';
import { useForm } from "@mantine/form";
import { useDebouncedValue } from "@mantine/hooks";
import { Row,Col} from 'react-bootstrap';
import { IconInfoCircle, IconMapPin } from "@tabler/icons-react";
import { SaveResponses } from "../actions/ResponsesActions";
import TypeTitleEnum  from '../enums/TypeTitleEnum';
import StudyLevelEnum from '../enums/StudyLevelEnum';
import { GetPaises,GetProvincias,GetCue} from "../actions/FormDataActions"
import { stepIds} from "../enums/fieldsDataConfig";
import { useStepResponses } from '../hooks/useStepResponses';
import useFormTracking from "../hooks/useFormTracking";
import debounce from "../hooks/Debounce";
import imagenCue from "../assets/cue.jpg";

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 100 }, (_, index) => currentYear - index);

const StudiesDataForm = forwardRef(({ stepNumber, t, id }, ref) => {

  const dispatch = useDispatch();

  const response = useSelector( (state) => state.respuestas.steps[stepNumber]?.responses || {} );
  const { data: dataPaises } = useSelector((state) => state.datosFormulario.paises);
  const { data: dataProvincias } = useSelector((state) => state.datosFormulario.provincias);
  const { data: cueData, loading: loadingCue } = useSelector((state) => state.datosFormulario.cue);
  const homologationResponse = useStepResponses(stepIds.HOMOLOGACION);
  
  const isListener = homologationResponse.catAlumno === 'oyente';
  const showMidStudies = !(homologationResponse.declaracion && t === 'g');
  const { track } = useFormTracking(stepNumber);
  const trackSelect = (fieldName) => (value) => {
    form.setFieldValue(fieldName, value);
    if (value) track('field_completed', { fieldName });
  };
  const [exampleModalOpen, setExampleModalOpen] = useState(false)
  const [disabledFields, setDisabledFields] = useState(false);

  const getValidations = (isListener,showMidStudies) => {
    if (!isListener) {
      if(showMidStudies){
        return {
          // Educación Secundaria
         // cueSecundario: (value) => (/^\d+$/.test(value) ? null : "Ingrese un CUE válido"),
          tituloSecundario: (value) => (/^[A-Za-zÁ-Üá-üÑñ\s]{3,60}$/.test(value || '') ? null : "Sólo letras (mín. 3)") ,
          institucionSecundaria: (value) => (/^[A-Za-zÁ-Üá-üÑñ\s]{3,60}$/.test(value || '') ? null : "Sólo letras (mín. 3)"),
          paisSecundario: (value) => (!value ? "El campo es obligatorio" : null),
          provinciaSecundario: (value) => (!value ? "El campo es obligatorio" : null),
          localidadSecundaria: (value) => (/^[A-Za-zÁ-Üá-üÑñ\s]{3,60}$/.test(value || '') ? null : "Sólo letras (mín. 3)"),
          anioEgresoSecundario: (value) => (!value ? "El campo es obligatorio" : null),
          promedioSecundario: (value) => (!value ? "Ingrese un promedio válido (0-10)" : null),
          //#region 
          /*tipoTituloSuperior: (value) => (value ? null : "El campo es obligatorio"),
          tituloSuperior: (value) => (value?.length > 2 ? null : "El campo es obligatorio"),
          institucionSuperior: (value) => (value?.length > 2 ? null : "El campo es obligatorio"),
          paisSuperior: (value) => (value ? null : "El campo es obligatorio"),
          provinciaSuperior: (value) => (value ? null : "El campo es obligatorio"),
          anioEgresoSuperior: (value) => (value ? null : "El campo es obligatorio"),
          promedioSuperior: (value) =>
            /^\d+(\.\d{1,2})?$/.test(value) && Number.parseFloat(value) <= 10 ? null : "Ingrese un promedio válido (0-10)",

          nivelEstudioNoCulminado: (value) => (value ? null : "El campo es obligatorio"),
          tipoTituloNoCulminado: (value) => (value ? null : "El campo es obligatorio"),
          tituloNoCulminado: (value) => (value?.length > 2 ? null :"El campo es obligatorio"),
          institucionNoCulminada: (value) => (value?.length > 2 ? null :"El campo es obligatorio"),
          anioInicioNoCulminado: (value) => (value ? null : "El campo es obligatorio"),
          anioFinNoCulminado: (value, valuees) => {
            if (!value) return "El campo es obligatorio"
            if (Number.parseInt(value) < Number.parseInt(valuees.anioInicioNoCulminado))
              return "El año de fin debe ser posterior al año de inicio"
            return null
          },
          promedioNoCulminado: (value) =>
            /^\d+(\.\d{1,2})?$/.test(value) && Number.parseFloat(value) <= 10 ? null : "Ingrese un promedio válido (0-10)",
          paisNoCulminado: (value) => (value ? null : "El campo es obligatorio"),
          provinciaNoCulminada: (value) => (value ? null : "El campo es obligatorio"),
          localidadNoCulminada: (value) => (value?.length > 2 ? null :"El campo es obligatorio"),*/
          //#endregion
          // Validaciones suaves (opcionales): si el usuario escribe, validar solo letras 3–60
          tituloSuperior: (value) => {
            if (!value) return null; // opcional
            return /^[A-Za-zÁ-Üá-üÑñ\s]{3,60}$/.test(value) ? null : "Sólo letras (mín. 3)";
          },
          institucionSuperior: (value) => {
            if (!value) return null; // opcional
            return /^[A-Za-zÁ-Üá-üÑñ\s]{3,60}$/.test(value) ? null : "Sólo letras (mín. 3)";
          },
          localidadSuperior: (value) => {
            if (!value) return null; // opcional
            return /^[A-Za-zÁ-Üá-üÑñ\s]{3,60}$/.test(value) ? null : "Sólo letras (mín. 3)";
          },

          // Superior: si el usuario completa algo en la sección, exigir mínimos
          anioEgresoSuperior: (value, values) => {
            // Disparar requerimientos SOLO si el usuario cargó algo relevante en Superior (no contar país/provincia por defecto)
            const hasSuperiorInput = !!(values.tipoTituloSuperior || values.tituloSuperior || values.institucionSuperior || values.localidadSuperior);
            if (!hasSuperiorInput) return null;
            return value ? null : "El campo es obligatorio";
          },
          paisSuperior: (value, values) => {
            const hasSuperiorInput = !!(values.tipoTituloSuperior || values.tituloSuperior || values.institucionSuperior || values.localidadSuperior || values.anioEgresoSuperior);
            if (!hasSuperiorInput) return null;
            return value ? null : "El campo es obligatorio";
          },
          provinciaSuperior: (value, values) => {
            const hasSuperiorInput = !!(values.tipoTituloSuperior || values.tituloSuperior || values.institucionSuperior || values.localidadSuperior || values.anioEgresoSuperior);
            if (!hasSuperiorInput) return null;
            if (values.paisSuperior !== 'AR') return null;
            return value ? null : "Seleccione una provincia";
          },
          provinciaDescripcionSuperior: (value, values) => {
            const hasSuperiorInput = !!(values.tipoTituloSuperior || values.tituloSuperior || values.institucionSuperior || values.localidadSuperior || values.anioEgresoSuperior);
            if (!hasSuperiorInput) return null;
            if (values.paisSuperior === 'AR') return null;
            return (value && value.length > 0) ? null : "Ingrese la provincia";
          },

          tituloNoCulminado: (value) => {
            if (!value) return null; // opcional
            return /^[A-Za-zÁ-Üá-üÑñ\s]{3,60}$/.test(value) ? null : "Sólo letras (mín. 3)";
          },
          institucionNoCulminada: (value) => {
            if (!value) return null; // opcional
            return /^[A-Za-zÁ-Üá-üÑñ\s]{3,60}$/.test(value) ? null : "Sólo letras (mín. 3)";
          },
          localidadNoCulminada: (value) => {
            if (!value) return null; // opcional
            return /^[A-Za-zÁ-Üá-üÑñ\s]{3,60}$/.test(value) ? null : "Sólo letras (mín. 3)";
          },

          // No culminados: si el usuario completa algo en la sección, exigir mínimos
          anioInicioNoCulminado: (value, values) => {
            // Considerar como "usó la sección" si cargó algún campo clave, NO país/provincia por defecto
            const hasNCInput = !!(values.nivelEstudioNoCulminado || values.tipoTituloNoCulminado || values.tituloNoCulminado || values.institucionNoCulminada || values.localidadNoCulminada || values.promedioNoCulminado || values.anioFinNoCulminado);
            if (!hasNCInput) return null;
            return value ? null : "El campo es obligatorio";
          },
          anioFinNoCulminado: (value, values) => {
            const hasNCInput = !!(values.nivelEstudioNoCulminado || values.tipoTituloNoCulminado || values.tituloNoCulminado || values.institucionNoCulminada || values.localidadNoCulminada || values.promedioNoCulminado || values.anioInicioNoCulminado);
            if (!hasNCInput) return null;
            if (!value) return "El campo es obligatorio";
            if (values.anioInicioNoCulminado && parseInt(value, 10) < parseInt(values.anioInicioNoCulminado, 10)) {
              return "El año de fin debe ser posterior al año de inicio";
            }
            return null;
          },
          paisNoCulminado: (value, values) => {
            const hasNCInput = !!(values.nivelEstudioNoCulminado || values.tipoTituloNoCulminado || values.tituloNoCulminado || values.institucionNoCulminada || values.localidadNoCulminada || values.promedioNoCulminado || values.anioInicioNoCulminado || values.anioFinNoCulminado);
            if (!hasNCInput) return null;
            return value ? null : "El campo es obligatorio";
          },
          provinciaNoCulminado: (value, values) => {
            const hasNCInput = !!(values.nivelEstudioNoCulminado || values.tipoTituloNoCulminado || values.tituloNoCulminado || values.institucionNoCulminada || values.localidadNoCulminada || values.promedioNoCulminado || values.anioInicioNoCulminado || values.anioFinNoCulminado);
            if (!hasNCInput) return null;
            if (values.paisNoCulminado !== 'AR') return null;
            return value ? null : "Seleccione una provincia";
          },
          provinciaDescripcionNoCulminado: (value, values) => {
            const hasNCInput = !!(values.nivelEstudioNoCulminado || values.tipoTituloNoCulminado || values.tituloNoCulminado || values.institucionNoCulminada || values.localidadNoCulminada || values.promedioNoCulminado || values.anioInicioNoCulminado || values.anioFinNoCulminado);
            if (!hasNCInput) return null;
            if (values.paisNoCulminado === 'AR') return null;
            return (value && value.length > 0) ? null : "Ingrese la provincia";
          },
        };
      } else {
        return {};
      }
    } else {
      return {};
    }
  };

  const form = useForm({
    initialValues: {
      //Educación Secundaria
      tituloSecundario: response.tituloSecundario || "",
      cueSecundario: response.cueSecundario || "",
      institucionSecundaria: response.institucionSecundaria || "",
      paisSecundario: response.paisSecundario || 'AR',
      provinciaSecundario: response.provinciaSecundario || null,
      provinciaDescripcionSecundario: response.provinciaDescripcionSecundario || null,
      localidadSecundaria: response.localidadSecundaria || "",
      anioEgresoSecundario: response.anioEgresoSecundario || null,
      promedioSecundario: response.promedioSecundario || "",
      direccionSecundaria:response.direccionSecundaria || "",

      //Educacion Superior
      tipoTituloSuperior: response.tipoTituloSuperior || null,
      tituloSuperior: response.tituloSuperior || "",
      institucionSuperior: response.institucionSuperior || "",
      paisSuperior: response.paisSuperior || 'AR',
      provinciaSuperior: response.provinciaSuperior || null,
      localidadSuperior: response.localidadSuperior || "",
      provinciaDescripcionSuperior: response.provinciaDescripcionSuperior || null,
      anioEgresoSuperior: response.anioEgresoSuperior || null,
      promedioSuperior: response.promedioSuperior || "",

      //Educacion Universitaria/Cursos no Culminados
      nivelEstudioNoCulminado: response.nivelEstudioNoCulminado || null,
      tipoTituloNoCulminado: response.tipoTituloNoCulminado || null,
      tituloNoCulminado: response.tituloNoCulminado || "",
      institucionNoCulminada: response.institucionNoCulminada || "",
      anioInicioNoCulminado: response.anioInicioNoCulminado || null,
      anioFinNoCulminado: response.anioFinNoCulminado || null,
      promedioNoCulminado: response.promedioNoCulminado || "",
      paisNoCulminado: response.paisNoCulminado || 'AR',
      provinciaNoCulminado: response.provinciaNoCulminado || null,
      provinciaDescripcionNoCulminado: response.provinciaDescripcionNoCulminado || null,
      localidadNoCulminada: response.localidadNoCulminada || "",
    },
    validate: getValidations(isListener,showMidStudies),
  });
  
  const [debouncedValues] = useDebouncedValue(form.values, 300);
    
  useEffect(() => {
    dispatch(SaveResponses(id, debouncedValues));
  }, [debouncedValues, dispatch, id]);

  useEffect(() => {
    dispatch(GetPaises())
  }, [])

  useEffect(() => {

    if (cueData && cueData.length > 0) {
      const schoolData = cueData[0]
      form.setValues((prev) => ({
        ...prev,
        paisSecundario:dataPaises.label="AR",
        institucionSecundaria: schoolData.nombre || "",
        provinciaSecundaria: dataProvincias.find((p) => p.label.toLocaleLowerCase().trim()===schoolData.provincia.toLowerCase().trim()).value || "",
        localidadSecundaria: schoolData.localidad || "",
        direccionSecundaria: schoolData.domicilio || "",
      }));
      setDisabledFields(true);
    }
    else 
    {
      setDisabledFields(false);
    }
  }, [cueData])

  useImperativeHandle(ref, () => ({
    validate: () => {
      const validation = form.validate();
      if (validation.hasErrors) {
        Object.keys(validation.errors).forEach((field) =>
          track('field_error', { fieldName: field })
        );
        return false;
      }
      return true;
    },
  }));

  const handleSavePais = (campo, pais) => {
    form.setValues({[`pais${campo}`]: pais});
    form.setValues({[`provincia${campo}`]: null});
    form.setValues({[`provinciaDescripcion${campo}`]: null});
    if (pais) track('field_completed', { fieldName: `pais${campo}` });
  };

  const handleSaveResponseProvincia = (campo, provincia) => {
    let prov = dataProvincias.find((p) => p.value === provincia);
    if (prov) {
      form.setValues({[`provincia${campo}`]: prov.value});
      form.setValues({[`provinciaDescripcion${campo}`]: prov.label});
    } else {
      form.setValues({[`provincia${campo}`]: 'OTR'});
      form.setValues({[`provinciaDescripcion${campo}`]: provincia});
    }
    if (provincia) track('field_completed', { fieldName: `provincia${campo}` });
  };

  const handleSaveResponseCue = debounce((value) => {
    if (value && value.length === 9) { // Solo buscar si el CUE tiene 9 dígitos
      
      dispatch(GetCue(value));
      form.setValues((prev) => ({
        ...prev,
        cueSecundario:value,
      }));

    } else {
      // Si el CUE no tiene 9 dígitos o está vacío, limpiar los campos relacionados
      form.setValues((prev) => ({
        ...prev,
        cueSecundario:value,
        institucionSecundaria: "",
        provinciaSecundaria: "",
        localidadSecundaria: "",
        direccionSecundaria: "",
        paisSecundario:"",
     
      }));
      setDisabledFields(false);
    }
  }, 700); // 700 ms de espera

  return (
    <Container size="100%" >
      {isListener ? (
        <Group justify="center">
          <Alert maw={'60%'} m={'2rem'} variant="transparent" color="#f20a61" radius="md" title="Este paso no es requerido" icon={<IconInfoCircle/>}>
            Dado que seleccionaste la opción <b>"Oyente"</b>, no es necesario que completes este formulario. Puedes proceder directamente al siguiente paso del proceso.
          </Alert>
        </Group>
      ):(
        <>
          {showMidStudies && (
            <>
              <Text size="xl" fw={500} mb={'xs'} c={'rgb(85, 85, 85)'}>Estudios de nivel medio - (Secundario)</Text>
              <Row className='row-inputs'>
                <Col md={4}>
                  <TextInput
                    required
                    label="Título"
                    placeholder='Bachiller en Ciencias Sociales'
                  {...form.getInputProps("tituloSecundario")}
                  onKeyDown={(e)=>{ if(!/[A-Za-zÁ-Üá-üÑñ\s]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') e.preventDefault(); }}
                  />
                </Col>
                <Col md={4}>
                <TextInput
                  label={
                    <Group spacing={3}> {/* Reducimos el espacio entre el texto y el enlace */}
                      <Text 
                      style={{ 
                        fontFamily: 'Montserrat, serif', // Aplica la fuente Greycliff CF
                        fontSize: '14px', // Tamaño de la fuente
                        fontWeight:'500',
                      }}
                    >
                      CUE
                    </Text>
                      <Anchor
                        onClick={() => setExampleModalOpen(true)}
                        style={{
                          color: 'black', // Color inicial negro
                          fontSize: '14px',
                          fontFamily: 'Montserrat, serif',
                          fontWeight:'500',
                          cursor: 'pointer',
                          textDecoration:'underline',
                          marginLeft: '1px', // Menos espacio entre el texto y el enlace
                        }}
                        onMouseEnter={(e) => (e.target.style.color = '#f20a61')} // Cambia el color al pasar el mouse
                        onMouseLeave={(e) => (e.target.style.color = 'black')} // Vuelve al color inicial al 
                      >
                        (ver ejemplo)
                      </Anchor>
                    </Group>
                  }
                  placeholder="Ingrese el CUE"
                  type="number"
                  onChange={(event) => handleSaveResponseCue(event.target.value)}
                  rightSection={
                    <Group spacing={5}>
                      {loadingCue && <Loader color="pink" size="sm" />}
                      {form.values.direccionSecundaria && (
                        <Tooltip
                          label={form.values.direccionSecundaria}
                          position="top"
                          withArrow
                          transitionProps={{ transition: "fade", duration: 200 }}
                        >
                          <IconMapPin size="1.2rem" style={{ color: "#f20a61", cursor: "pointer" }} />
                        </Tooltip>
                      )}
                    </Group>
                  }
                  rightSectionWidth={50}
                />
                </Col>
                <Col md={4}>
                  <TextInput
                    required
                    label="Institución"
                    placeholder='Colegio Esteban Echeverría'
                    {...form.getInputProps("institucionSecundaria")}
                    disabled={disabledFields}
                  onKeyDown={(e)=>{ if(!/[A-Za-zÁ-Üá-üÑñ\s]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') e.preventDefault(); }}

                  />
                </Col>
              </Row>
              <Row className='row-inputs'>
                <Col md={4}>
                  <Select
                    required
                    searchable
                    label="País"
                    data={dataPaises}
                    checkIconPosition='right'
                    placeholder='Argentina'
                    {...form.getInputProps("paisSecundario", {
                      onChange: (value) => {
                        handleSavePais('Secundario',value);
                      },
                    })}
                    disabled={disabledFields}
                  />
                </Col>
                <Col md={4}>
                  {form.values.paisSecundario==='AR' ?(
                    <Select
                      required
                      searchable
                      label="Provincia"
                      data={dataProvincias}
                      checkIconPosition='right'
                      placeholder='Seleccione una opción'
                      {...form.getInputProps("provinciaSecundario", {
                        onChange: (value) => {
                          handleSaveResponseProvincia('Secundario',value);
                        },
                      })}
                      disabled={disabledFields}
                    />
                  ):( 
                    <TextInput
                      required
                      label="Provincia"
                      placeholder="Ingrese la provincia"
                      {...form.getInputProps("provinciaDescripcionSecundario", {
                        onChange: (e) => {
                          handleSaveResponseProvincia('Secundario',e.target.value);
                        },
                      })}
                    />
                  )}
                </Col>
                <Col md={4}>
                  <TextInput
                    required
                    label="Localidad"
                    placeholder='CABA'
                    {...form.getInputProps("localidadSecundaria")}
                    disabled={disabledFields}
                  onKeyDown={(e)=>{ if(!/[A-Za-zÁ-Üá-üÑñ\s]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') e.preventDefault(); }}

                  />
                </Col>
              </Row>
              <Row className='row-inputs'>
                <Col md={6}>
                  <Select
                    required
                    label="Año que egresó"
                    checkIconPosition='right'
                    data={years.map(year => ({
                        value: year.toString(),
                        label: year.toString(),
                    }))}
                    placeholder="Seleccionar año"
                    //onChange={(value) => handleSaveResponse('anioEgresoSecundario',value)}
                    {...form.getInputProps("anioEgresoSecundario")}
                    onChange={trackSelect('anioEgresoSecundario')}
                  />
                </Col>
                <Col md={6}>
                  <NumberInput
                    label="Promedio"
                    required
                    min={0}
                    max={10}
                    placeholder='7.00'
                    //onChange={(value) => handleSaveResponse('promedioSecundario',value)}
                    {...form.getInputProps("promedioSecundario")}
                  />
                </Col>
              </Row>
            </>
          )}
          <Text size="xl" fw={500} mb={'xs'} mt={'xl'} c={'rgb(85, 85, 85)'}>Estudios de nivel superior</Text>
          <Row className='row-inputs'>
            <Col md={4}>
              <Select
                label="Tipo Título"
                data={TypeTitleEnum}
                placeholder='Seleccione una opción'
                //onChange={(value) => handleSaveResponse('tipoTituloSuperior',value)}
                {...form.getInputProps("tipoTituloSuperior")}
                onChange={trackSelect('tipoTituloSuperior')}
              />
            </Col>
            <Col md={4}>
              <TextInput
                label="Título"
                placeholder='Técnico/a en Refrigeración'
                //onChange={(value) => handleSaveResponse('tituloSuperior',value)}
                  {...form.getInputProps("tituloSuperior")}
                  onKeyDown={(e)=>{ if(!/[A-Za-zÁ-Üá-üÑñ\s]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') e.preventDefault(); }}
              />
            </Col>
            <Col md={4}>
              <TextInput
                label="Institución"
                placeholder='UAI'
                //onChange={(value) => handleSaveResponse('institucionSuperior',value)}
                  {...form.getInputProps("institucionSuperior")}
                  onKeyDown={(e)=>{ if(!/[A-Za-zÁ-Üá-üÑñ\s]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') e.preventDefault(); }}
              />
            </Col>
          </Row>
          <Row className='row-inputs'>
            <Col md={4}>
              <Select
                searchable
                label="País"
                data={dataPaises}
                checkIconPosition='right'
                placeholder='Seleccione un país'
                {...form.getInputProps("paisSuperior", {
                  onChange: (value) => {
                    handleSavePais('Superior',value);
                  },
                })}
              />
            </Col>
            <Col md={4}>
              {form.values.paisSuperior ==='AR' ? (
                <Select
                  searchable
                  label="Provincia"
                  data={dataProvincias}
                  checkIconPosition='right'
                  placeholder='Seleccione una provincia'
                  {...form.getInputProps("provinciaSuperior", {
                    onChange: (value) => {
                      handleSaveResponseProvincia('Superior',value);
                    },
                  })}
                />
              ) : (
                <TextInput
                  label="Provincia"
                  placeholder="Ingrese la provincia"
                  {...form.getInputProps("provinciaDescripcionSuperior", {
                    onChange: (e) => {
                      handleSaveResponseProvincia('Superior',e.target.value);
                    },
                  })}
                />
              )}
            </Col>
            <Col md={4}>
              <TextInput            
                label="Localidad"
                placeholder='Ingrese una localidad'
                //onChange={(value) => handleSaveResponse('localidadSuperior',value)}
                  {...form.getInputProps("localidadSuperior")}
                  onKeyDown={(e)=>{ if(!/[A-Za-zÁ-Üá-üÑñ\s]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') e.preventDefault(); }}
              />
            </Col>
          </Row>
          <Row className='row-inputs'>
            <Col md={6}>
              <Select
                label="Año que egresó"    
                checkIconPosition='right'       
                data={years.map(year => ({
                    value: year.toString(),
                    label: year.toString(),
                }))}
                placeholder="Seleccionar año"
                //onChange={(value) => handleSaveResponse('anioEgresoSuperior',value)}
                {...form.getInputProps("anioEgresoSuperior")}
                onChange={trackSelect('anioEgresoSuperior')}
              />
            </Col>
            <Col md={6}>
              <NumberInput
                label="Promedio"
                min={0}
                max={10}
                placeholder='7.00'
                //onChange={(value) => handleSaveResponse('promedioSuperior',value)}
                {...form.getInputProps("promedioSuperior")}
              />
            </Col>
          </Row>
    
          <Text size="xl" fw={500} mb={'xs'} mt={'xl'} c={'rgb(85, 85, 85)'}>Carreras Terciarias ó Universitarias cursadas y no culminadas</Text>
          <Row>
            <Col md={4}>
              <Select
                label="Nivel máximo de estudios no culminados:"
                data={StudyLevelEnum}
                checkIconPosition='right'
                placeholder='Seleccione una opción'
                //onChange={(value) => handleSaveResponse('nivelEstudioNoCulminado',value)}
                {...form.getInputProps("nivelEstudioNoCulminado")}
                onChange={trackSelect('nivelEstudioNoCulminado')}
              />
            </Col>
            <Col md={4}>
              <Select           
                label="Tipo Título"
                data={TypeTitleEnum}
                checkIconPosition='right'
                placeholder='Seleccione el tipo de título'
                //onChange={(value) => handleSaveResponse('tipoTituloNoCulminado',value)}
                {...form.getInputProps("tipoTituloNoCulminado")}
                onChange={trackSelect('tipoTituloNoCulminado')}
              />
            </Col>
            <Col md={4}>
              <TextInput            
                label="Título"
                placeholder='Ingrese el nombre del título'
                //onChange={(value) => handleSaveResponse('tituloNoCulminado',value)}
                  {...form.getInputProps("tituloNoCulminado")}
                  onKeyDown={(e)=>{ if(!/[A-Za-zÁ-Üá-üÑñ\s]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') e.preventDefault(); }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <TextInput            
                label="Institución"
                placeholder='Universidad Abierta Interamericana'
                //onChange={(value) => handleSaveResponse('institucionNoCulminada',value)}
                  {...form.getInputProps("institucionNoCulminada")}
                  onKeyDown={(e)=>{ if(!/[A-Za-zÁ-Üá-üÑñ\s]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') e.preventDefault(); }}
              />
            </Col>
            <Col md={3}>
              <Select
                label="Año de inicio de cursada"    
                checkIconPosition='right'       
                data={years.map(year => ({
                    value: year.toString(),
                    label: year.toString(),
                }))}
                placeholder="Seleccionar año"
                //onChange={(value) => handleSaveResponse('anioInicioNoCulminado',value)}
                {...form.getInputProps("anioInicioNoCulminado")}
                onChange={trackSelect('anioInicioNoCulminado')}
              />
            </Col>
            <Col md={3}>
              <Select
                label="Ultimo año de cursada"  
                checkIconPosition='right'         
                data={years.map(year => ({
                    value: year.toString(),
                    label: year.toString(),
                }))}
                placeholder="Seleccionar año"
                //onChange={(value) => handleSaveResponse('anioFinNoCulminado',value)}
                {...form.getInputProps("anioFinNoCulminado")}
                onChange={trackSelect('anioFinNoCulminado')}
              />
            </Col>
            <Col md={3}>
              <NumberInput
                label="Promedio"
                placeholder='7.00'
                min={0}
                max={10}
                //onChange={(value) => handleSaveResponse('promedioNoCulminado',value)}
                {...form.getInputProps("promedioNoCulminado")}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Select
                searchable
                label="País"
                data={dataPaises}
                checkIconPosition='right'
                placeholder='Seleccione una opción'
                {...form.getInputProps("paisNoCulminado", {
                  onChange: (value) => {
                    handleSavePais('NoCulminado',value);
                  },
                })}
              />
            </Col>
            <Col md={4}>
              {form.values.paisNoCulminado ==='AR' ? (
                <Select
                  searchable
                  label="Provincia"
                  data={dataProvincias}
                  checkIconPosition='right'
                  placeholder='Seleccione una provincia'
                  {...form.getInputProps("provinciaNoCulminado", {
                    onChange: (value) => {
                      handleSaveResponseProvincia('NoCulminado',value);
                    },
                  })}
                />
              ):(
                <TextInput
                  label="Provincia"
                  placeholder="Ingrese la provincia"
                  {...form.getInputProps("provinciaDescripcionNoCulminado", {
                    onChange: (e) => {
                      handleSaveResponseProvincia('NoCulminado',e.target.value);
                    },
                  })}
                />
              )}
            </Col>
            <Col md={4}>
              <TextInput
                
                label="Localidad"
                placeholder='Ingrese una localidad'
                //onChange={(value) => handleSaveResponse('localidadNoCulminada',value)}
                  {...form.getInputProps("localidadNoCulminada")}
                  onKeyDown={(e)=>{ if(!/[A-Za-zÁ-Üá-üÑñ\s]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') e.preventDefault(); }}
              />
            </Col>
          </Row>
          <Modal
            opened={exampleModalOpen}
            onClose={() => setExampleModalOpen(false)}
            title="Clave Única de identificación que poseen todos los establecimientos educativos reconocidos en forma oficial"
            size="xl" // Cambia el tamaño del modal a "xl" para que sea más grande
          >
            <Image
              src={imagenCue}
              alt="Ejemplo de CUE"
              fit="contain"
              style={{
                width: '100%', // Asegura que ocupe todo el ancho disponible
                height: 'auto', // Mantiene la proporción original de la imagen
                maxHeight: '600px', // Aumenta la altura máxima para que la imagen sea más grande
              }}
            />
          </Modal>
        </>
      )}
    </Container>
  );
});

export default StudiesDataForm;
